import { ICareMap, ISupportGroupKey } from './ICareMap';
import { ArrayOfAll } from '../utils/ArrayOfAll';

export class SupportGroupKeySorter {

    getSortedSupportGroupKeys = (caremap?: Partial<ICareMap>) => {

        const defaultSortOrder: ArrayOfAll<ISupportGroupKey> = ['community', 'school', 'medical', 'specialists', 'financial', 'social'];

        if (!caremap) {
            return defaultSortOrder;
        }

        const supportGroups = defaultSortOrder.map((supportGroupKey, index) => {
            return {
                supportGroupKey,
                isRelevant: caremap[supportGroupKey]?.isRelevant,
                isRelevantSince: caremap[supportGroupKey]?.isRelevantSince || new Date(index).toISOString()
            };
        });

        const sortOrder = supportGroups.filter(s => s.isRelevant)
            .sort((l, r) => l.isRelevantSince.localeCompare(r.isRelevantSince))
            .map(s => s.supportGroupKey);

        return sortOrder;
    };

}
